/**
 * @name getModalTitle
 * @function
 * @description Заголовок модалки
 * @param modalData {object} - данные модалки (из листинга сервисов)
 */
export const getModalTitle = (modalData) => {
  if (modalData && modalData.id) {
    const { id } = modalData;
    return `Edit category (ID: ${id})`;
  }
  return 'Create category';
};

/**
 * @name getIcon
 * @function
 * @description Возвращаем объект icon
 * @param modalData {object} - данные модалки (из листинга сервисов)
 * @return
 *  {
 *    icon_type: 'emoji',
 *    icon: '👍
 *  }
 */
export const getIcon = (modalData) => {
  if (modalData && modalData.icon) {
    const { icon } = modalData;
    return icon;
  }
  return null
};
